import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import type { AdItem } from '@sbt-web/network/types';
import { buildImageObjSchema } from './utils';
type Props = {
  adItem: AdItem;
};
export const ImgObjSchemaAdDetail: FC<Props> = t0 => {
  const $ = _c(2);
  const {
    adItem: ad
  } = t0;
  let t1;
  if ($[0] !== ad) {
    const imgSchemaObjs = ad.images?.map((img, idx) => buildImageObjSchema({
      ad,
      image: `${img.cdnBaseUrl}?rule=fullscreen-1x-auto`,
      isRepresentative: idx === 0
    })).filter(_temp);
    t1 = imgSchemaObjs.length > 0 ? <script key="addetail-image-object" {...jsonLdScriptProps({
      "@context": "https://schema.org",
      "@graph": imgSchemaObjs
    })} /> : null;
    $[0] = ad;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(imgObj) {
  return imgObj !== null;
}